import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { AuthService } from 'src/app/services/auth.service';
import { Question, UserInterests, UserResponse } from '../../models/user-interests';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-interests-dialog',
  templateUrl: './interests-dialog.component.html',
  styleUrls: ['./interests-dialog.component.scss'],
})
export class InterestsDialogComponent implements OnInit, OnDestroy {
  formGroups: UntypedFormGroup[] = [];
  showForm: boolean;
  waiting: boolean;
  userName: string;
  interests: UserInterests;
  questions: Question[] = [];
  subscriptions: Subscription[];

  constructor(
    authService: AuthService,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: UserInterests,
    public dialogRef: MatDialogRef<InterestsDialogComponent>
  ) {
    this.subscriptions = [];
    this.interests = data;
    this.showForm = false;
    this.userName = authService.getLoggedUser().name;

    this.interests.formQuestionDTOList.forEach((q) => {
      this.questions.push(Question.fromDTO(q));
    });
  }

  ngOnInit() {
    this.questions.forEach((q) => {
      const formGroup = this.formBuilder.group({
        [q.id]: ['', q.type === 'RADIOBUTTON' ? Validators.required : Validators.nullValidator],
      });

      this.formGroups.push(formGroup);
    });
  }

  close(remindLater: boolean) {
    if (remindLater) {
      sessionStorage.setItem('interestsDismiss', 'true');
    } else {
      this.userService.setDontShowInterests();
    }

    this.dialogRef.close();
  }

  startForm() {
    this.showForm = true;
  }

  onSelected(step: number, questionId: number, values: string[]) {
    this.formGroups[step].controls[questionId].setValue(values);
  }

  submit() {
    const responses: UserResponse[] = this.questions.map((q) => ({
      questionId: q.id,
      response: q.finalUserResponses,
    }));

    this.waiting = true;
    this.subscriptions.push(
      this.userService.setUserInterests(responses).subscribe(
        () => (window as any).location.reload(),
        () => (this.waiting = false)
      )
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sbs) => sbs.unsubscribe());
  }
}
